//src/lib/tokenStorage.ts
const TOKEN_KEY = "auth_token";

const hasWindow = typeof window !== "undefined";

export function getToken(): string | null {
  if (!hasWindow) return null; // SSR-safe
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(token: string | null): void {
  if (!hasWindow) return; // SSR-safe
  try {
    if (token) window.localStorage.setItem(TOKEN_KEY, token);
    else window.localStorage.removeItem(TOKEN_KEY);
  } catch {
    // ignore storage errors
  }
}
